import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HomePageRU = lazy(() => import('../pages/home-ru/page'));
const HomePageUS = lazy(() => import('../pages/home-us/page'));
const KatalogPage = lazy(() => import('../pages/katalog/page'));
const FuarlarTR = lazy(() => import('../pages/fuarlar/FuarlarTR'));
const FuarlarEN = lazy(() => import('../pages/fuarlar/FuarlarEN'));
const YerlesimPlaniPage = lazy(() => import('../pages/yerlesim-plani/page'));
const LayoutPlanPage = lazy(() => import('../pages/layout-plan/page'));
const KesimKalinliklariTR = lazy(() => import('../pages/kesim-kalinliklari/KesimKalinliklariTR'));
const KesimKalinliklariEN = lazy(() => import('../pages/kesim-kalinliklari/KesimKalinliklariEN'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ProductsPage = lazy(() => import('../pages/products/page'));

const routes: RouteObject[] = [
  // Turkish Routes
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/katalog',
    element: <KatalogPage />,
  },
  {
    path: '/fuarlar',
    element: <FuarlarTR />,
  },
  {
    path: '/yerlesim-plani',
    element: <YerlesimPlaniPage />,
  },
  {
    path: '/kesim-kalinliklari',
    element: <KesimKalinliklariTR />,
  },
  {
    path: '/products/:productSlug',
    element: <ProductsPage />,
  },
  // English Routes
  {
    path: '/en',
    element: <HomePage />,
  },
  {
    path: '/en/catalog',
    element: <KatalogPage />,
  },
  {
    path: '/en/fairs',
    element: <FuarlarEN />,
  },
  {
    path: '/en/layout-plan',
    element: <LayoutPlanPage />,
  },
  {
    path: '/en/cutting-thickness',
    element: <KesimKalinliklariEN />,
  },
  {
    path: '/en/products/:productSlug',
    element: <ProductsPage />,
  },
  // Russia Routes
  {
    path: '/ru',
    element: <HomePageRU />,
  },
  {
    path: '/ru/cutting-thickness',
    element: <KesimKalinliklariEN />,
  },
  {
    path: '/ru/products/:productSlug',
    element: <ProductsPage />,
  },
  // USA Routes
  {
    path: '/us',
    element: <HomePageUS />,
  },
  {
    path: '/us/fairs',
    element: <FuarlarEN />,
  },
  {
    path: '/us/cutting-thickness',
    element: <KesimKalinliklariEN />,
  },
  {
    path: '/us/products/:productSlug',
    element: <ProductsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
